import { DateModel } from "~/model"

export const RANGE_DATE_LIST = [
    {
        label: "Aujourd'hui",
        value: "today",
        startDate: DateModel.startOfDay,
        endDate: DateModel.endOfDay,
    },
    {
        label: "7 derniers jours",
        value: "last_7_days",
        startDate: DateModel.startOf7DaysAgo,
        endDate: DateModel.endOfDay,
    },
    {
        label: "30 derniers jours",
        value: "last_30_days",
        startDate: DateModel.startOf30DaysAgo,
        endDate: DateModel.endOfDay,
    },
    {
        label: "Cette semaine",
        value: "current_week",
        startDate: DateModel.startOfWeek,
        endDate: DateModel.endOfWeek,
    },
    {
        label: "Semaine dernière",
        value: "last_week",
        startDate: DateModel.lastWeekStart,
        endDate: DateModel.lastWeekEnd,
    },
    {
        label: "Semaine prochaine",
        value: "next_week",
        startDate: DateModel.nextWeekStart,
        endDate: DateModel.nextWeekEnd,
    },
    {
        label: "Ce mois-ci",
        value: "current_month",
        startDate: DateModel.startOfMonth,
        endDate: DateModel.endOfMonth,
    },
    {
        label: "Mois suivant",
        value: "next_month",
        startDate: DateModel.startOfNextMonth,
        endDate: DateModel.endOfNextMonth,
    },
    {
        label: "Mois dernier",
        value: "last_month",
        startDate: DateModel.startOfLastMonth,
        endDate: DateModel.endOfLastMonth,
    },
    {
        label: "3 derniers mois",
        value: "last_3_months",
        startDate: DateModel.startOf3MonthsAgo,
        endDate: DateModel.endOfMonth,
    },
    {
        label: "Cette année",
        value: "current_year",
        startDate: DateModel.startOfYear,
        endDate: DateModel.endOfYear,
    },
    {
        label: "Periode personnalisée",
        value: "custom",
        startDate: null,
        endDate: null,
    },
]

export const CALENDAR_DATE_VIEW = [
    {
        label: "Semaine",
        value: "timeGridWeek",
        title: (date: Date) => {
            const weekNumber = DateModel.weekNumber(date)
            return `Semaine ${weekNumber}`
        },
    },
    {
        label: "Jour",
        value: "timeGridDay",
        title: (date: Date) => {
            return DateModel.formatShort(date)
        },
    },
    {
        label: "Liste",
        value: "listWeek",
        title: (date: Date) => {
            const weekNumber = DateModel.weekNumber(date)
            return `Semaine ${weekNumber}`
        },
    },
]
